import React from 'react';

export const renderOfficialWebsite = (website) => (
  <a href={encodeURI(website)} target='_blank' rel='noopener noreferrer'>
    {website}
  </a>
);
